<template>
    <div class="ContentIndex">
        <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div>
        <div class="shop-overview padding-20 bgc box-shadow" style="margin-top: 20px;">
            <div class="title_warp">
                <p>商品总览</p>
            </div>
            <div class="shop-overview-box">
                <div class="box"  v-for="(item, index) in goodsTypeData" :key="index">
                    <img :src="item.icon" alt="" class="icon-cms">
                    <div>
                        <div>
                            <span class="title">{{item.type}}</span>
                            <el-tooltip placement="top" popper-class="ContentIndex-tooltip">
                                <div class="tooltip_content"  slot="content">当前时间，已上架的{{item.type}}商品数量</div>
                                <img class="tooltip_icon" :src="icon1" alt="">
                            </el-tooltip>
                        </div>
                        <div class="total">{{item.num}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shop-overview padding-20 bgc box-shadow">
            <div class="title_warp">
                <p>商品排行</p>
                <div class="search_box">
                    <div style="width: 100px;">
                        <el-select v-model="goodsRankValue" placeholder="自然天">
                            <el-option v-for="item in goodsRankOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div>
                        <el-date-picker :clearable="false" v-model="goodsRankDateValue" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions1" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                    <div style="margin-right: 0px;">
                        <el-button type="primary" @click="GoodsRankSearch" plain>搜索</el-button>
                    </div>
                    <!-- <p><img :src="reportIcon" alt="">导出</p> -->
                </div>
            </div>
            <GoodsTable :goodsTableData="goodsTableData"></GoodsTable>
        </div>
        <div class="shop-overview padding-20 bgc box-shadow">
            <div class="title_warp">
                <p>商品效果</p>
                <div class="search_box">
                    <div style="width: 110px">
                        <el-select v-model="goodsTypeValue" placeholder="全部类型">
                            <el-option v-for="item in goodsTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div>
                        <el-input v-model="goodsNameValue" placeholder="请输入商品名称" class="condition" clearable></el-input>
                    </div>
                    <div style="width: 100px">
                        <el-select v-model="goodsDateOptionValue" placeholder="自然天">
                            <el-option v-for="item in goodsDateOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div v-show="goodsDateOptionValue === 1">
                        <el-date-picker :clearable="false" v-model="goodsDateValue" align="left" type="date" :placeholder="getDateTime(0)" :picker-options="pickerOptions1"></el-date-picker>
                    </div>
                    <div v-show="goodsDateOptionValue === 2">
                        <el-date-picker :clearable="false" :picker-options="disabledDatePickerOptions" v-model="goodsDateValue" align="left" type="week" format="yyyy 第 WW 周" placeholder="选择周"></el-date-picker>
                    </div>
                    <div v-show="goodsDateOptionValue === 3">
                        <el-date-picker :clearable="false" :picker-options="disabledDatePickerOptions" v-model="goodsDateValue" align="left" type="month" placeholder="选择月"></el-date-picker>
                    </div>
                    <div v-show="goodsDateOptionValue === 4">
                        <el-date-picker
                            :picker-options="disabledDatePickerOptions"
                            :clearable="false"
                            format="yyyy-MM-dd"
                            v-model="goodsPeriodTime"
                            align="left"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div style="margin-right: 20px;">
                        <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
                    </div>
                    <p @click="exportClick"><img :src="reportIcon" alt="">导出</p>
                </div>
            </div>
            <div class="goods_table_warp">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column type="index" label="排名" width="80" align='center'></el-table-column>
                    <el-table-column label="商品名称" width="360">
                        <template slot-scope="scope">
                            <div class="goods_name_box">
                                <img :src="scope.row.coveratturlid" alt="">
                                <div>
                                    <p>{{scope.row.kmcname}}</p>
                                    <p>{{scope.row.kmctypeName}}</p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="viewcount" label="访问量" align='center'></el-table-column>
                    <el-table-column prop="visitclientsum" label="访客数" align='center'></el-table-column>
                    <el-table-column prop="paycustomersum" label="付费用户" align='center'></el-table-column>
                    <el-table-column prop="totalincome" label="付款金额" align='center'></el-table-column>
                    <el-table-column prop="conversionRate" label="转换率" align='center'></el-table-column>
                    <el-table-column label="操作" align='center' class-name="operation">
                        <template slot-scope="scope">
                            <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <page :total="total" ref="page" @getList="goodsEffectSearch"></page>
            </div>
        </div>
    </div>
</template>

<script>
import GoodsTable from 'views/dataCenter/dataTabs/components/GoodsTable'
import {getCommodity, getContentData, getCommodityEffect, getContentList} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import Page from 'base/page/page'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'ContentIndex',
    data() {
        return {
            activeIndex: '4',
            goodsTableData: {}, // 商品看板data
            total: 0,
            img: require('@/common/images/logo.png'),
            icon1: require('@/common/images/other/data_center_tools_icon@2x.png'),
            reportIcon: require('@/common/images/other/data_center_report_icon@2x.png'),
            goodsTypeData: [
                {
                    icon: require('@/common/images/other/data_center_tuwen_icon@2x.png'),
                    type: '图文',
                    num: 109
                },
                {
                    icon: require('@/common/images/other/data_center_baogao_icon@2x.png'),
                    type: '报告',
                    num: 20
                },
                {
                    icon: require('@/common/images/other/data_center_spzb_icon@2x.png'),
                    type: '视频直播',
                    num: 0
                },
                {
                    icon: require('@/common/images/other/data_center_tpzb_icon@2x.png'),
                    type: '图片直播',
                    num: 0
                },
                {
                    icon: require('@/common/images/other/data_center_shiping_icon@2x.png'),
                    type: '视频',
                    num: 0
                },
                {
                    icon: require('@/common/images/other/data_center_zhuanti_icon@2x.png'),
                    type: '专题',
                    num: 12
                },
                {
                    icon: require('@/common/images/other/data_center_kecheng_icon@2x.png'),
                    type: '课程',
                    num: 0
                }
            ],
            tableData: [],
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                },
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', date)
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', date)
                        }
                    }
                ]
            },
            disabledDatePickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                }
            },
            goodsRankValue: 1,
            goodsRankDateValue: this.getDateTime(0),
            goodsRankOptions: [
                {
                    value: 1,
                    label: '自然天'
                }
            ],
            goodsTypeValue: '',
            goodsTypeOptions: [
                {
                    value: '',
                    label: '全部类型'
                },
                {
                    value: 1,
                    label: '图文'
                },
                {
                    value: 2,
                    label: '报告'
                },
                {
                    value: 3,
                    label: '直播'
                },
                {
                    value: 4,
                    label: '视频'
                },
                {
                    value: 5,
                    label: '专题'
                }
            ],
            goodsNameValue: '',
            goodsDateOption: [
                {
                    value: 1,
                    label: '自然天'
                },
                {
                    value: 2,
                    label: '自然周'
                },
                {
                    value: 3,
                    label: '自然月'
                },
                {
                    value: 4,
                    label: '自定义'
                }
            ],
            goodsDateOptionValue: 1,
            goodsDateValue: '',
            goodsPeriodTime: ''
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        profileData() {
            this.$router.push({name: 'ProfileData'})
        },
        traffic() {
            this.$router.push({name: 'Traffic'})
        },
        trading() {
            this.$router.push({name: 'Trading'})
        },
        content() {
            this.$router.push({name: 'Content'})
        },
        user() {
            this.$router.push({name: 'User'})
        },
        init() {
            this.findContentData()
            this.findCommodity()
            this.findCommodityEffect()
        },
        // 商品效果导出
        exportClick() {
            if (this.goodsDateOptionValue === 1 || this.goodsDateOptionValue === 2 || this.goodsDateOptionValue === 3) {
                if (this.goodsDateValue === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            if (this.goodsDateOptionValue === 4) {
                if (this.goodsPeriodTime === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {}
            if (this.goodsDateOptionValue === 1) {
                params = {
                    beginTime: this.transferDate(this.goodsDateValue),
                    endTime: this.transferDate(this.goodsDateValue)
                }
            } else if (this.goodsDateOptionValue === 2) {
                params = {
                    beginTime: this.getWeek(this.goodsDateValue)[0],
                    endTime: this.getWeek(this.goodsDateValue)[1]
                }
            } else if (this.goodsDateOptionValue === 3) {
                params = {
                    beginTime: this.getMonth(this.goodsDateValue)[0],
                    endTime: this.getMonth(this.goodsDateValue)[1]
                }
            } else if (this.goodsDateOptionValue === 4) {
                params = {
                    beginTime: this.transferDate(this.goodsPeriodTime[0]),
                    endTime: this.transferDate(this.goodsPeriodTime[1])
                }
            }
            getContentList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '商品效果' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleView(row) {
            this.$router.push({name: 'ContentGoodsInfo', query: {id: row.innerid, type: row.kmctype}})
        },
        // 获取--商品总览
        findContentData() {
            this.setLoading(true)
            getContentData({
                success: data => {
                    this.setLoading(false)
                    this.goodsTypeData[0].num = data.data.mapNumber.article
                    this.goodsTypeData[2].num = data.data.mapNumber.livevideo
                    this.goodsTypeData[1].num = data.data.mapNumber.report
                    this.goodsTypeData[5].num = data.data.mapNumber.spackage
                    this.goodsTypeData[4].num = data.data.mapNumber.video
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 商品排名搜索
        GoodsRankSearch() {
            this.setLoading(true)
            var params = {
                screenTime: this.goodsRankDateValue,
                datacount: 5
            }
            getCommodity({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsTableData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--商品排名
        findCommodity() {
            this.setLoading(true)
            var params = {
                screenTime: this.getDateTime(0),
                datacount: 5
            }
            getCommodity({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsTableData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 搜索商品效果data
        goodsEffectSearch() {
            if (this.goodsDateOptionValue === 1 || this.goodsDateOptionValue === 2 || this.goodsDateOptionValue === 3) {
                if (this.goodsDateValue === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            if (this.goodsDateOptionValue === 4) {
                if (this.goodsPeriodTime === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {
                kmctype: this.goodsTypeValue,
                kmcname: this.goodsNameValue,
                timeStatus: this.goodsDateOptionValue,
                beginTime: this.transferDate(this.goodsDateValue)
            }
            if (this.goodsDateOptionValue === 4) {
                params.beginTime = this.transferDate(this.goodsPeriodTime[0])
                params.endTime = this.transferDate(this.goodsPeriodTime[1])
            }
            getCommodityEffect({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.visitorList
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--商品效果初始化data数据
        findCommodityEffect() {
            this.setLoading(true)
            var params = {
                timeStatus: 1,
                beginTime: this.getDateTime(0)
            }
            getCommodityEffect({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.visitorList
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        getWeek(value) {
            // 按周日为一周的最后一天计算
            var date = value
            // 今天是这周的第几天
            var today = date.getDay()
            // 上周日距离今天的天数（负数表示）
            var stepSunDay = -today + 1
            // 如果今天是周日
            if (today === 0) {
                stepSunDay = -7
            }
            // 周一距离今天的天数（负数表示）
            var stepMonday = 7 - today
            var time = date.getTime()
            var monday = new Date(time + stepSunDay * 24 * 3600 * 1000)
            var sunday = new Date(time + stepMonday * 24 * 3600 * 1000)
            // 本周一的日期 （起始日期）
            var startDate = this.transferDate(monday) // 日期变换
            // 本周日的日期 （结束日期）
            var endDate = this.transferDate(sunday) // 日期变换
            return [startDate, endDate]
        },
        getMonth(value) {
            // 获取当前月的第一天
            var start = value
            start.setDate(1)
            // 获取当前月的最后一天
            var date = value
            var currentMonth = date.getMonth()
            var nextMonth = ++currentMonth
            var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
            var oneDay = 1000 * 60 * 60 * 24
            var end = new Date(nextMonthFirstDay - oneDay)
            var startDate = this.transferDate(start) // 日期变换
            var endDate = this.transferDate(end) // 日期变换
            return [startDate, endDate]
        },
        transferDate(date) {
            // 年
            var year = date.getFullYear()
            // 月
            var month = date.getMonth() + 1
            // 日
            var day = date.getDate()
            if (month >= 1 && month <= 9) {
                month = '0' + month
            }
            if (day >= 0 && day <= 9) {
                day = '0' + day
            }
            var dateString = year + '-' + month + '-' + day
            return dateString
        },
        // 获取昨日 日期
        getDateTime(type) {
            // type :  1--今天日期  0--昨天日期
            var time = null
            if (type === 1) {
                time = (new Date()).getTime()
            } else if (type === 0) {
                time = (new Date()).getTime() - 24 * 60 * 60 * 1000
            }
            var dateTime = new Date(time) // 获取的是前一天日期
            var year = dateTime.getFullYear()
            var month = dateTime.getMonth() + 1
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        // 获取本月/上一个月 自然天前上一周日期
        getDateMonthTime(type) {
            var time = (new Date()).getTime() - 7 * 24 * 60 * 60 * 1000
            var dateTime = new Date(time)
            var year = dateTime.getFullYear()
            var month = null
            if (type === 1) {
                month = dateTime.getMonth() + 1
            }
            if (type === 0) {
                month = dateTime.getMonth()
            }
            if (month === 0) {
                month = 12
                year = year - 1
            }
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        GoodsTable,
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.ContentIndex {
    .title_warp {
        padding: 0 20px 0 10px;
        margin-bottom: 20px;
        height: 50px;
        background-color: #F5F7FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &>p {
            border-left: 2px solid #409EFF;
            padding-left: 8px;
            color: #303133;
        }
        .search_box{
            display: flex;
            align-items: center;
            .el-input__inner {
                height: 36px;
            }
            .el-input__icon {
                line-height: 0;
                height: 36px;
            }
            .el-button {
                height: 36px;
            }
            &>div{
                height: 36px;
                vertical-align: middle;
                // width: 240px;
                margin-right: 20px;
                .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
                    width: 240px;
                }
                .el-date-editor .el-range-separator {
                    line-height: 28px;
                }
            }
            &>p {
                color: #409EFF;
                cursor: pointer;
                img{
                    width: 16px;
                    height: 14px;
                    margin-right: 8px;
                }
            }
        }
    }
    .shop-overview{
        margin-bottom: 20px;
        .tooltip_icon{
            width: 13px;
            height: 13px;
            cursor: pointer;
        }
        .shop-overview-box{
            @include flexBox(space-between);
            padding: 0 30px;
            .box{
                @include flexBox(flex-start);
                padding: 20px 0;
                .icon-cms{
                    width: 52px;
                    height: 52px;
                    margin-right: 10px;
                }
                .title{
                    font-size: $font-14;
                    margin-right: 10px;
                }
                .total{
                    font-size: $font-20;
                    color: $tcolor-base;
                    margin-top: 10px;
                }
            }
        }
        .goods_table_warp{
            .el-table th>.cell {
                font-weight: 600;
            }
            .goods_name_box{
                display: flex;
                &>img{
                    width: 106px;
                    height: 60px;
                    margin-right: 10px;
                }
                &>div{
                    width: 224px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    p:nth-of-type(1) {
                        width: 100%;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    p:nth-of-type(2) {
                        color: #fff;
                        width:36px;
                        height:17px;
                        line-height:17px;
                        text-align: center;
                        background-color: #409EFF;
                        border-radius:2px;
                    }
                }
            }
        }
    }
}
.ContentIndex-tooltip{
    .tooltip_content{
        width: 350px;
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
/* .el-table__empty-block {
    height: 320px!important;
}
.el-table__empty-text {
    margin-top: 190px;
} */
</style>